export const DEFAULT_LANGUAGE = "en";
export const DEFAULT_STORAGE_URL = "../..";
export const DEFAULT_API_URL = "https://api.staging.audience.direct";

export enum AppType {
    CONTENT_APP = "CONTENT_APP",
    MODULE = "MODULE"
}

export enum EngineMode {
    CONTENT_APP_EDITOR = "CONTENT_APP_EDITOR",
    PRESENTATION_EDITOR = "PRESENTATION_EDITOR",
    PREPARE = "PREPARE",
    PRESENT = "PRESENT",
    VIEWER = "VIEWER",
    TRAIN = "TRAIN"
}

export enum AppMode {
    DEVELOPMENT = 'development',
    PRODUCTION = 'production'
}

export enum InitPageState {
    IDLE,
    WORKING,
    ERROR
}

export enum ModuleFunction {
    SET_PARAMS = "setParams",
    SET_MODULE_DATA = "setModuleData",
    SET_AUDIENCE_DATA = "setAudienceData",
    PAUSE = "pause",
    PLAY = "play"
}

export enum ApiUrls {
    CLIENT_API = "client-api",
    PORTAL_API = "portal-api",
    PROJECT_API = "project-api"
}
